<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/stock/damages">{{ $t('stock_damage') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('new') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('branch') }}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.BranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('date') }}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.Date" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('remark') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.Remark" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="grid">
                                <thead>
                                <tr>
                                    <th>{{$t('item_name')}}</th>
                                    <th>{{$t('description')}}</th>
                                    <th style="width: 120px">{{$t('qty')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(ret, index) in lines" :key="index">
                                    <td><AuthCompleted @select="select($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                    <td class="text-center">
                                        <input type="text" class="form-control form-control-sm" v-model="ret.Description">
                                    </td>
                                    <td class="text-right">
                                        <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" />
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    export default {
        components: {
            AuthCompleted
        },
        data(){
            return {
                header: {
                    Date: this.$now().format('YYYY-MM-DD')
                },
                lines: [
                    {
                        ItemId: '',
                        ItemName: '',
                        Description: '',
                        Quantity: 1
                    }
                ],
                branchs: []
            }
        },
        created(){
            this.branchList();
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
                this.findById(id);
            }
        },
        methods: {
            branchList(){
                this.$api().post('branch/list', { Limit: 0 }).then(res => {
                    if(this.$isValid(res)){
                        this.branchs = res.data.Data;
                    }
                });
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('stock/damage/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.header = res.data.Json.Header;
                        this.lines = res.data.Json.Lines;
                    }
                }).finally(() => { loading.hide()});
            },
            save(){
                var loading = this.$loading.show();
                var req = {
                    Header: this.header,
                    Lines: this.lines
                }
                this.$api().post('stock/damage/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/stock/damages');
                    }
                }).finally(() => { loading.hide()});
            },
            select(e, item){
                item.ItemId = e.Id;
                item.ItemName = e.Name;
            },
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
</style>
